/**
 * The on-site client's address as one line: street, then postal code and
 * city (« Rue des Chasseurs 5, 7100 La Louvière »). Clients often type the
 * whole address in the street field: the locality is not repeated then.
 */
export function fullAddress(client) {
  if (!client) return '';
  const street = (client.address || '').trim();
  const city = (client.city || '').trim();
  const locality = [client.postal_code, client.city]
    .map((part) => (part || '').trim())
    .filter(Boolean)
    .join(' ');
  if (!locality) return street;
  const lower = street.toLowerCase();
  if (lower.includes(locality.toLowerCase()) || (city && lower.includes(city.toLowerCase()))) return street;
  return [street, locality].filter(Boolean).join(', ');
}

/**
 * The intervention address to show after the on-site client changes.
 *
 * By default it is the new client's address — but only while the field is
 * empty or still holds the previous client's address: a place typed by hand
 * (the flat downstairs, a second site) is never overwritten.
 */
export function addressAfterClientChange(current, previousClient, nextClient) {
  const now = (current || '').trim();
  const previousDefault = fullAddress(previousClient);
  if (!now || (previousDefault && now === previousDefault)) return fullAddress(nextClient);
  return current;
}
